export const YES_NO_OPTIONS = [{ label: "Yes", value: "true" }, { label: "No", value: "false" }];

export const wellTypeOpts = ["", "AG", "Galvanized", "Galvanized Pipe", "Irrigation", "MONITOR", "Observation", "Pipe", "Residential", "Stockwatering", "SUBMERSE AG", "SUBMERSE DOM", "Unknown"];

export const agencyOpts = ["", "City of Fresno", "Fresno Irrigation District", "DWR"];